module.exports = __webpack_public_path__ + "static/img/order-code.011bd304.png";